import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const verticalTabsDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
